import { IconButton, Tooltip, useMediaQuery } from "@mui/material";
import { useControls } from "react-zoom-pan-pinch";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import { scaleValue } from "../../atoms";
import { useRecoilState } from "recoil";
import CenterFocusStrongIcon from "@mui/icons-material/CenterFocusStrong";

function CenterView() {
  const { zoomIn, zoomOut, centerView } = useControls();
  const [zoomValue, setZoomValue] = useRecoilState(scaleValue);
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Tooltip title="Cneter">
      <IconButton
        aria-label="Cneter"
        color="primary"
        onClick={() => centerView(zoomValue, 500, "easeOut")}
        sx={{ marginRight: isMobile ? 0 : 2 }}
      >
        <CenterFocusStrongIcon />
      </IconButton>
      {/* <button>List</button> */}
    </Tooltip>
  );
}

export default CenterView;
